import { Palette } from '@common/theming/Palette';
import React, { useEffect, useState } from 'react';
import { ImageGalleryWeb } from '../components/ImageGalleryWeb';
import { Asset } from '../elements/Desktop';
import { PortfolioAsset } from '../types';

type AssetDesktopProps = {
  asset: PortfolioAsset;
};

type AssetDesktopState = 'ASSET' | 'IMAGE_GALLERY';
const AssetDesktop: React.FC<AssetDesktopProps> = ({ asset }) => {
  const [currentState, setCurrentState] = useState<AssetDesktopState>('ASSET');
  useEffect(() => {
    document.body.style.backgroundColor = Palette.WHITE;
  });

  const showImageGallery = () => {
    setCurrentState('IMAGE_GALLERY');
  };
  let content;

  switch (currentState) {
    case 'ASSET':
      content = <Asset asset={asset} showImageGallery={showImageGallery} />;
      break;
    case 'IMAGE_GALLERY':
      content = (
        <ImageGalleryWeb
          header={true}
          images={asset ? asset?.images.map((image) => image.file.url) : []}
          mode="desktop"
          showAsset={() => setCurrentState('ASSET')}
          title={asset?.header.title}
        />
      );
      break;
  }
  return content;
};

export default AssetDesktop;
